import React from "react";
import "./Brands.css";

import zaraLogo from '../assets/zara1.png';
import guizioLogo from '../assets/guizio1.png';
import skimsLogo from '../assets/skims1.png';
import aloLogo from '../assets/alo1.png';
import aritziaLogo from '../assets/aritzia1.png'; 
import withJeanLogo from '../assets/withjean1.png'; 
import bananaRepublicLogo from "../assets/bananar1.png";
import princessPollyLogo from "../assets/princesspolly.png";
import victoriasSecretLogo from "../assets/vs1.png";
import onLogo from "../assets/on1.png";

// New brand imports
import reformationLogo from '../assets/reformation_logo.png';
import theoryLogo from '../assets/Theory-logo.png';
import vinceLogo from '../assets/vince-logo-vector.png';
import arLogo from '../assets/AR-Logo.png';
import luluLogo from '../assets/lululemon-logo.png';
import ediktedLogo from '../assets/edikted-logo.png';
import uniqloLogo from '../assets/uniqlologo.png';
import petermillarLogo from '../assets/petermillar-logo.png';

const Brands = () => {
  const brands = [
    {
      name: "Zara",
      logo: zaraLogo,
      style: { maxWidth: "80%", maxHeight: "70px" },
    },
    {
      name: "Guizio",
      logo: guizioLogo,
    },
    {
      name: "Skims",
      logo: skimsLogo,
    },
    {
      name: "Alo",
      logo: aloLogo,
      style: { maxHeight: "80px", maxWidth: "80%" },
    },
    {
      name: "Aritzia",
      logo: aritziaLogo,
      style: { maxWidth: "90%", maxHeight: "80px" },
    },
    {
      name: "With Jéan",
      logo: withJeanLogo,
    },
    {
      name: "Banana Republic",
      logo: bananaRepublicLogo,
      style: { maxWidth: "85%", maxHeight: "70px" },
    },
    {
      name: "Princess Polly",
      logo: princessPollyLogo,
      style: { maxWidth: "75%", maxHeight: "65px" },
    },
    {
      name: "Victoria's Secret",
      logo: victoriasSecretLogo,
      style: { maxWidth: "70%", maxHeight: "65px", transform: "scale(1.8)" },
    },
    {
      name: "On",
      logo: onLogo,
      style: { maxHeight: "75px", maxWidth: "75%" },
    },
    {
      name: "Reformation",
      logo: reformationLogo,
      style: { maxWidth: "85%", maxHeight: "70px" },
    },
    {
      name: "Theory",
      logo: theoryLogo,
      style: { maxWidth: "80%", maxHeight: "65px" },
    },
    {
      name: "Vince",
      logo: vinceLogo,
      style: { maxWidth: "80%", maxHeight: "65px" },
    },
    {
      name: "Asta Resort",
      logo: arLogo,
      style: { maxWidth: "85%", maxHeight: "70px" },
    },
        {
      name: "Edikted",
      logo: ediktedLogo,
      style: { maxWidth: "85%", maxHeight: "70px" },
    },
        {
      name: "LuluLemon",
      logo: luluLogo,
      style: { maxWidth: "85%", maxHeight: "70px" },
    },
        {
      name: "Peter Millar",
      logo: petermillarLogo,
      style: { maxWidth: "85%", maxHeight: "70px" },
    },
    {
      name: "Uniqlo",
      logo: uniqloLogo,
      style: { maxWidth: "85%", maxHeight: "70px" },
    }
  ];

  return (
    <div className="brands-page-container">
      <div className="brands-header">
        <h2 className="brands-main-title">OUR BRANDS</h2>
        <p className="brands-sub-text">
          Discover top brands that we partner with to bring you the best in fashion and style
        </p>
      </div>
      
      <div className="brands-grid-wrapper">
        {brands.map((brand, index) => (
          <div key={index} className="brand-grid-card">
            <img 
              src={brand.logo} 
              alt={`${brand.name} logo`} 
              className="brand-grid-logo" 
              style={brand.style || {}}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Brands;